"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Label = _interopRequireDefault(require("../Label"));

var _Validation = _interopRequireDefault(require("../Validation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Scaffold = function Scaffold(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      error = _ref.error,
      id = _ref.id,
      label = _ref.label,
      theme = _ref.theme,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "error", "id", "label", "theme", "type"]);

  return _react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])(classes.root, className)
  }, rest), label && _react["default"].createElement(_Label["default"], {
    htmlFor: id
  }, label), children, error && _react["default"].createElement(_Validation["default"], {
    error: error
  }));
};

var styles = function styles() {
  return {
    root: {
      position: "relative",
      width: "100%",
      margin: "8px auto 16px"
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "EuiScaffold"
})(Scaffold);

exports["default"] = _default;